import { render, staticRenderFns } from "./ui-avatar.vue?vue&type=template&id=59af4748&"
import script from "./ui-avatar.vue?vue&type=script&lang=ts&"
export * from "./ui-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./ui-avatar.vue?vue&type=style&index=0&id=59af4748&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports